import { render, staticRenderFns } from "./InstructionsContainer.vue?vue&type=template&id=17d3fe47&scoped=true&"
var script = {}
import style0 from "./InstructionsContainer.vue?vue&type=style&index=0&id=17d3fe47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3fe47",
  null
  
)

export default component.exports